import {RoutePaths} from '../../routing/RoutePath'

export const Engagement = []
export const Convert = []
export const System = []
export const Capture = []

export const Campaign = [
  ////////////////////////////////FRONTEND USER//////////////////////////////////////////////
  {
    to: '/inbox',
    icon: '/media/icons/duotune/navigationicon/messages.svg',
    title: 'Inbox',
    Permissions: 'show-inbox',
  },
  {
    to: '/subAccount/user',
    icon: '/media/icons/duotune/communication/com014.svg',
    title: 'Sub Client Accounts',
    Permissions: 'manage-sub-client-user',
  },

  {
    to: '/message',
    icon: '/media/icons/duotune/navigationicon/bulkmsg.svg',
    title: 'Send Message',
    Permissions: 'all',
    subMenu: [
      {
        to: '#',
        hasBullet: true,
        title: 'Quick Message',
        Permissions: 'send-quick-sms',
      },
      {
        to: '/new-message',
        hasBullet: true,
        title: 'Send Campaign',
        Permissions: 'send-quick-sms',
      },
      {
        to: '/templates/savedCampaign',
        title: 'Saved Campaigns',
        hasBullet: true,
        Permissions: 'segments-list',
      },
      {
        to: '/file-scheduler',
        hasBullet: true,
        title: 'File Scheduler',
        Permissions: 'send-quick-sms',
      },
    ],
  },

  // Feature Flow

  {
    to: '/contacts',
    title: 'Contacts',
    icon: '/media/icons/duotune/communication/com005.svg',
    Permissions: 'contacts-list',
    subMenu: [
      {
        to: '/contacts/subscriber',
        title: 'All Contacts',
        hasBullet: true,
        Permissions: 'contacts-list',
      },
      {to: '/contacts/list', title: 'List', hasBullet: true, Permissions: 'tags-list'},
      {to: '/contacts/tags', title: 'Tags', hasBullet: true, Permissions: 'tags-list'},
      {to: '/contacts/segments', title: 'Segments', hasBullet: true, Permissions: 'segments-list'},
      {
        to: '/contacts/upload-history',
        title: 'Upload History',
        hasBullet: true,
        Permissions: 'contacts-list',
      },
      {
        to: '/contacts/unsubscribe',
        title: 'Unsubscribed',
        hasBullet: true,
        Permissions: 'contacts-list',
      },
    ],
  },

  {
    to: '/report-analytics',
    icon: '/media/icons/duotune/graphs/gra007.svg',
    title: 'Reports & Analytics',
    Permissions: 'all',
    subMenu: [
      {
        to: '/report-analytics/insight',
        title: 'Insight',
        hasBullet: true,
        Permissions: 'all',
      },
      {
        to: '/report-analytics/bulk-messages',
        title: 'Campaign reports',
        hasBullet: true,
        Permissions: 'all',
      },
      {
        to: '/report-analytics/activity-logs',
        title: 'Activity Log',
        hasBullet: true,
        Permissions: 'all',
      },
      // {
      //   to: '/report-analytics/quick-messages',
      //   title: 'Quick message',
      //   hasBullet: true,
      //   Permissions: 'all',
      // },
      // {
      //   to: '/report-analytics/api-messages',
      //   title: 'Api message',
      //   hasBullet: true,
      //   Permissions: 'all',
      // },
      // {
      //   to: '/report-analytics/email-to-sms-messages',
      //   title: 'Email to sms',
      //   hasBullet: true,
      //   Permissions: 'all',
      // },
      {
        to: '/report-analytics/short-link',
        title: 'Short Link ',
        hasBullet: true,
        Permissions: 'all',
      },
      {
        to: '/report-analytics/landing-page',
        title: 'Landing Pages',
        hasBullet: true,
        Permissions: 'all',
      },
      {
        to: '/report-analytics/scheduler-messages',
        title: 'File Scheduled',
        hasBullet: true,
        Permissions: 'send-quick-sms',
      },
      {
        to: '/report-analytics/flow',
        title: 'Flow Reports',
        hasBullet: true,
        Permissions: 'all',
      },
    ],
  },

  {
    to: '/topup',
    icon: '/media/icons/duotune/navigationicon/cash.svg',
    fontIcon: 'bi-cash-coin',
    title: 'Purchase Credit',
    Permissions: 'purchase-credits',
  },

  // {
  //   to: '/custom-outout',
  //   icon: '/media/icons/duotune/general/gen040.svg',
  //   title: 'Custom Opt-out Survey',
  //   Permissions: 'all',
  // },
]

export const CampaignRegion = [
  ////////////////////////////////FRONTEND USER//////////////////////////////////////////////
  {
    to: '/message',
    icon: '/media/icons/duotune/navigationicon/bulkmsg.svg',
    title: 'Send Message',
    Permissions: 'all',
    subMenu: [
      {
        to: '#',
        icon: '',
        fontIcon: 'bi-send',
        title: 'Quick Message',
        Permissions: 'send-quick-sms',
      },
      {
        to: '/new-message',
        icon: '/media/icons/duotune/navigationicon/bulkmsg.svg',
        title: 'Send Campaign',
        Permissions: 'send-quick-sms',
      },
      // {
      //   to: '/templates/savedCampaign',
      //   title: 'Saved Campaigns',
      //   hasBullet: true,
      //   Permissions: 'segments-list',
      // },
      // {
      //   to: '/file-scheduler',
      //   icon: '/media/icons/duotune/files/fil016.svg',
      //   title: 'File Scheduler',
      //   Permissions: 'send-quick-sms',
      // },
    ],
  },
  {
    to: '/contacts',
    title: 'Contacts',
    icon: '/media/icons/duotune/communication/com005.svg',
    Permissions: 'contacts-list',
    subMenu: [
      {
        to: '/contacts/subscriber',
        title: 'All Contacts',
        hasBullet: true,
        Permissions: 'contacts-list',
      },
      {to: '/contacts/list', title: 'List', hasBullet: true, Permissions: 'tags-list'},
      {to: '/contacts/tags', title: 'Tags', hasBullet: true, Permissions: 'tags-list'},
      // { to: '/contacts/segments', title: 'Segments', hasBullet: true, Permissions: 'segments-list' },
      {
        to: '/contacts/upload-history',
        title: 'Upload History',
        hasBullet: true,
        Permissions: 'contacts-list',
      },
      {
        to: '/contacts/unsubscribe',
        title: 'Unsubscribed',
        hasBullet: true,
        Permissions: 'contacts-list',
      },
    ],
  },
  {
    to: '/report-analytics',
    icon: '/media/icons/duotune/graphs/gra007.svg',
    title: 'Reports & Analytics',
    Permissions: 'all',
    subMenu: [
      {
        to: '/report-analytics/bulk-messages',
        title: 'Campaign reports',
        hasBullet: true,
        Permissions: 'all',
      },
      {
        to: '/report-analytics/activity-logs',
        title: 'Activity Log',
        hasBullet: true,
        Permissions: 'all',
      },
      {
        to: '/report-analytics/flow',
        title: 'Flow Reports',
        hasBullet: true,
        Permissions: 'all',
      },
      // {
      //   to: '/report-analytics/quick-messages',
      //   title: 'Quick message',
      //   hasBullet: true,
      //   Permissions: 'all',
      // },
    ],
  },
]

export const More = [
  {
    to: '/accounts',
    icon: '',
    fontIcon: 'bi-person',
    title: 'My Account',
    Permissions: 'all',
    subMenu: [
      {
        to: '/accounts/billing?scrollId=purchase-history',
        title: 'Billing History',
        hasBullet: true,
        Permissions: 'create-auto-popup-setting',
      },
      {
        to: '/accounts/balance-history',
        title: 'Credit History',
        hasBullet: true,
        Permissions: 'create-auto-popup-setting',
      },
    ],
  },
  {
    to: '/sender-id',
    icon: '/media/icons/duotune/navigationicon/medal_star.svg',
    title: "Register Sender ID's",
    Permissions: 'show-dedicated-number',
  },

  {
    to: '/sender-id',
    title: 'Dedicated Numbers',
    icon: '/media/icons/duotune/navigationicon/phone.svg',
    Permissions: 'purchase-dedicated-number',
  },
  // {
  //   to: '/topup',
  //   title: 'Purchase credit',
  //   icon: '/media/icons/duotune/navigationicon/cash.svg',
  //   Permissions: 'purchase-credits',
  // },
  {
    to: '/integration',
    icon: '/media/icons/duotune/navigationicon/cloud.svg',
    title: 'Integrations',
    Permissions: 'all',
  },
  {
    to: '/setting',
    icon: '',
    fontIcon: 'bi-gear',
    title: 'Settings',
    Permissions: 'all',
    subMenu: [
      {
        to: '/email-to-sms',
        hasBullet: true,
        title: 'Email to SMS',
        Permissions: 'all',
      },
      {
        to: '/accounts/api-keys',
        title: 'API Setup',
        hasBullet: true,
        Permissions: 'send-quick-sms',
      },
      {
        to: '/accounts/billing?scrollId=auto-fill',
        title: 'Auto Top-up',
        hasBullet: true,
        Permissions: 'create-auto-popup-setting',
      },
      {
        to: '/accounts/team-list',
        title: 'Users',
        hasBullet: true,
        Permissions: 'list-sub-accounts',
      },
      {
        to: '/accounts/settings',
        title: 'Account Settings',
        hasBullet: true,
        Permissions: 'all',
      },
    ],
  },
]
export const MoreRegion = [
  {
    to: "/accounts/sender-id's",
    icon: '/media/icons/duotune/navigationicon/medal_star.svg',
    title: "Sender ID's",
    Permissions: 'show-dedicated-number',
  },
  {
    to: "/accounts/sender-id's",
    title: 'Dedicated Numbers',
    icon: '/media/icons/duotune/navigationicon/phone.svg',
    Permissions: 'purchase-dedicated-number',
  },
  {
    to: '/topup',
    title: 'Purchase credit ',
    icon: '/media/icons/duotune/navigationicon/cash.svg',
    Permissions: 'purchase-credits',
  },
  {
    to: '/integration',
    icon: '/media/icons/duotune/navigationicon/cloud.svg',
    title: 'Integrations',
    Permissions: 'all',
  },
  {
    to: '/setting',
    icon: '',
    fontIcon: 'bi-gear',
    title: 'Settings',
    Permissions: 'all',
    subMenu: [
      {
        to: '/email-to-sms',
        hasBullet: true,
        title: 'Email to SMS',
        Permissions: 'all',
      },
      {
        to: '/accounts/api-keys',
        title: 'API Setup',
        hasBullet: true,
        Permissions: 'all',
      },
      {
        to: '/accounts/billing?scrollId=purchase-history',
        title: 'Billing History',
        hasBullet: true,
        Permissions: 'create-auto-popup-setting',
      },
      {
        to: '/accounts/balance-history',
        title: 'Credit History',
        hasBullet: true,
        Permissions: 'create-auto-popup-setting',
      },
    ],
  },
]

export const Tools = [
  {
    to: '/templates/template',
    title: 'Message templates',
    icon: '/media/icons/duotune/navigationicon/archive.svg',
    Permissions: 'contacts-list',
  },
  {
    to: '/opt-out-list',
    icon: '/media/icons/duotune/general/gen040.svg',
    title: 'Custom opt-out',
    Permissions: 'custom-opt-out-list-management-list',
  },
  {
    to: '/landing-page',
    icon: '/media/icons/duotune/coding/cod006.svg',
    title: 'Landing Pages',
    Permissions: 'landing-pages-list',
  },
  {
    to: '/tools/form',
    title: 'Lead Capture Form',
    icon: '/media/icons/lead-capture-form.svg',
    Permissions: 'contacts-list',
  },
  {
    to: '/automation',
    icon: '/media/icons/duotune/navigationicon/data.svg',
    title: 'Automation',
    Permissions: 'all',
  },
]

export const WalletCardNotActivate = [
  {
    to: '/wallet-card/subscription',
    title: 'AI B-card',
    icon: '/media/icons/duotune/general/gen008.svg',
    fontIcon: '',
    Permissions: 'all',
  },
]
export const WalletCard = [
  {
    to: '/report-wallet-card',
    icon: '/media/icons/duotune/general/gen008.svg',
    fontIcon: '/media/icons/duotune/general/gen008.svg',
    title: 'Leads Dashboard',
    Permissions: 'all',
  },
  {
    to: '/contact-collection',
    icon: '/media/icons/duotune/navigationicon/phone_book.svg',
    fontIcon: '/media/icons/duotune/navigationicon/phone_book.svg',
    title: 'Lead Management',
    Permissions: 'all',
  },
  {
    to: '/wallet-card',
    icon: '/media/icons/duotune/navigationicon/business-card.svg',
    fontIcon: '/media/icons/duotune/navigationicon/business-card.svg',
    title: 'Wallet / Cards',
    Permissions: 'all',
  },
  {
    icon: '/media/icons/duotune/navigationicon/archive.svg',
    fontIcon: '/media/icons/duotune/navigationicon/archive.svg',
    title: 'Templates',
    Permissions: 'all',
    subMenu: [
      {
        to: '/card-templates',
        title: 'Wallet/card Templates',
        hasBullet: true,
        Permissions: 'all',
      },
      {
        to: '/templates/template',
        title: 'Message Templates',
        hasBullet: true,
        Permissions: 'all',
      },
      {
        to: '/wallet-nurture-flow',
        title: 'Nurture Flows',
        hasBullet: true,
        Permissions: 'all',
      },
    ],
  },
  {
    to: '/promo-action',
    icon: '/media/icons/duotune/finance/fin008.svg',
    fontIcon: '/media/icons/duotune/finance/fin008.svg',
    title: 'Card Offers',
    Permissions: 'all',
  },
  {
    to: '/team-list',
    icon: '/media/icons/duotune/users/users.svg',
    fontIcon: '/media/icons/duotune/users/users.svg',
    title: 'Team Members',
    Permissions: 'all',
  },
]

export const ToolsRegion = [
  {
    to: '/templates/template',
    title: 'Message templates',
    icon: '/media/icons/duotune/navigationicon/archive.svg',
    Permissions: 'contacts-list',
  },
]

/////////////////////////////////////////BACK END MENU////////////////////////

export const backEndMenu = [
  {
    to: '/sales',
    title: 'Sales Data',
    icon: '/media/icons/duotune/communication/com014.svg',
    Permissions: 'all',
    subMenu: [
      {
        to: 'sales/performance',
        title: 'Performance',
        hasBullet: true,
        Permissions: 'all',
      },
      {
        to: 'sales/potential-churn',
        title: 'Potential Churn',
        hasBullet: true,
        Permissions: 'all',
      },
      {
        to: 'sales/new-purchase',
        title: 'New Purchase',
        hasBullet: true,
        Permissions: 'create-staff',
      },
      {
        to: 'sales/all-purchase',
        title: 'All Purchase',
        hasBullet: true,
        Permissions: 'create-staff',
      },
      {
        to: 'sales/commissions',
        title: 'Commission',
        hasBullet: true,
        Permissions: 'all',
      },
      {
        to: 'sales/coupons',
        title: 'Coupons',
        hasBullet: true,
        Permissions: 'create-staff',
      },
    ],
  },
  {
    to: '/user-list',
    icon: '/media/icons/duotune/communication/com005.svg',
    title: 'User List',
    Permissions: 'users-list',
  },
  {
    to: '/whitelabel-list',
    icon: '/media/icons/duotune/communication/com005.svg',
    title: 'WhiteLabel List',
    Permissions: 'whitelabel-list',
  },

  // {
  //   to: '/report-analytics',
  //   icon: '/media/icons/duotune/graphs/gra007.svg',
  //   title: 'Reports & Analytics',
  //   Permissions: 'all',
  // },
  // {
  //   to: '/campaign-log',
  //   icon: '/media/icons/duotune/files/fil019.svg',
  //   title: 'Campaign Log',
  //   Permissions: 'all',
  // },
  // {
  //   to: '/support-ticket',
  //   icon: '/media/icons/duotune/abstract/abs027.svg',
  //   title: 'Support Ticket',
  //   Permissions: 'all',
  // },
  {
    to: '/campaign-log',
    icon: '/media/icons/duotune/files/fil019.svg',
    title: 'Campaign Log',
    Permissions: 'all',
  },
  {
    to: '/activity-log',
    icon: '/media/icons/duotune/files/fil019.svg',
    title: 'Activity Log',
    Permissions: 'all',
  },

  {
    to: '/dedicated-number',
    icon: '/media/icons/duotune/general/gen022.svg',
    title: 'Gateway Management',
    Permissions: 'gateways-list',
    subMenu: [
      {
        to: '/dedicated_Number',
        title: 'Dedicated Number',
        hasBullet: true,
        Permissions: 'gateways-list',
      },

      {
        to: '/shared-number',
        hasBullet: true,
        title: 'Shared Number',
        Permissions: 'gateways-list',
      },
      {
        to: '/config-gateways',
        hasBullet: true,
        title: 'Gateway Configs',
        Permissions: 'gateways-list',
      },
      {
        to: '/gateway',
        hasBullet: true,
        title: 'Gateway Provider',
        Permissions: 'gateways-list',
      },
    ],
  },
  // {
  //   to: '/Api',
  //   icon: '/media/icons/duotune/abstract/abs026.svg',
  //   title: 'Customer feedback',
  //   Permissions: 'all',
  // },
  {
    to: '/setup',
    title: 'Setup',
    icon: '/media/icons/duotune/coding/cod001.svg',
    Permissions: 'all',
    subMenu: [
      {
        to: 'setting/payment_gateways',
        title: 'Payment gateways',
        hasBullet: true,
        Permissions: 'payment-methods-list',
      },
      {
        to: 'setting/global_ratecard',
        title: 'Price Rules',
        hasBullet: true,
        Permissions: 'pricerules-list',
      },
      {
        to: 'setting/opt-out-list',
        title: 'Default Opt-Out List',
        hasBullet: true,
        Permissions: 'backend-optout-list',
      },
      {
        to: 'setting/global_setting',
        title: 'Global setting',
        hasBullet: true,
        Permissions: 'all',
      },
      {
        to: 'setting/mongo_scale',
        title: 'Mongo Scale',
        hasBullet: true,
        Permissions: 'all',
      },
      {
        to: 'setting/fraud_keyword',
        title: 'Fraud Keyword',
        hasBullet: true,
        Permissions: 'all',
      },
    ],
  },
  {
    to: '/user-survey',
    icon: '/media/icons/lead-capture-form.svg',
    title: 'User Survey',
    Permissions: 'users-list',
  },
  {
    to: '/admin/how-to-videos',
    icon: '/media/icons/duotune/general/gen017.svg',
    title: 'How-To Videos',
    Permissions: 'all',
  },
  {
    to: '/templates',
    title: 'Base Templates',
    icon: '/media/icons/duotune/navigationicon/archive.svg',
    Permissions: 'create-staff',
    subMenu: [
      {
        to: '/templates/message-template',
        title: 'Message Templates',
        hasBullet: true,
        Permissions: 'all',
      },
      {
        to: '/templates/base-tags',
        title: 'Tags',
        hasBullet: true,
        Permissions: 'all',
      },
      {
        to: '/templates/promo-actions',
        title: 'Card Offers',
        hasBullet: true,
        Permissions: 'all',
      },
      {
        to: '/templates/flows',
        title: 'Flows',
        hasBullet: true,
        Permissions: 'all',
      },
    ],
  },
  {
    to: '/system-alert',
    title: 'System Alert',
    icon: '/media/icons/duotune/communication/com004.svg',
    Permissions: 'all',
  },
]

export const backEndMenuRegion = [
  {
    to: '/user-list',
    icon: '/media/icons/duotune/communication/com005.svg',
    title: 'User List',
    Permissions: 'users-list',
  },
  {
    to: '/whitelabel-list',
    icon: '/media/icons/duotune/communication/com005.svg',
    title: 'WhiteLabel List',
    Permissions: 'whitelabel-list',
  },
  {
    to: '/support-ticket',
    icon: '/media/icons/duotune/abstract/abs027.svg',
    title: 'Support Ticket',
    Permissions: 'all',
  },
  {
    to: '/campaign-log',
    icon: '/media/icons/duotune/files/fil019.svg',
    title: 'Campaign Log',
    Permissions: 'all',
  },
  {
    to: '/gateway',
    icon: '/media/icons/duotune/general/gen022.svg',
    title: 'Gateway Management',
    Permissions: 'gateways-list',
  },
  {
    to: '/dedicated_Number',
    icon: '/media/icons/duotune/general/gen024.svg',
    title: 'Dedicated Numbers ',
    Permissions: 'backend-dedicatednumber-list',
  },
  {
    to: '/setup',
    title: 'Setup',
    icon: '/media/icons/duotune/coding/cod001.svg',
    Permissions: 'all',
    subMenu: [
      {
        to: 'setting/payment_gateways',
        title: 'Payment gateways',
        hasBullet: true,
        Permissions: 'payment-methods-list',
      },
      {
        to: 'setting/global_ratecard',
        title: 'Price Rules',
        hasBullet: true,
        Permissions: 'pricerules-list',
      },
      {
        to: 'setting/opt-out-list',
        title: 'Default Opt-Out List',
        hasBullet: true,
        Permissions: 'backend-optout-list',
      },
      {
        to: 'setting/global_setting',
        title: 'Global setting',
        hasBullet: true,
        Permissions: 'all',
      },
      {
        to: 'setting/mongo_scale',
        title: 'Mongo Scale',
        hasBullet: true,
        Permissions: 'all',
      },
      {
        to: 'setting/fraud_keyword',
        title: 'Fraud Keyword',
        hasBullet: true,
        Permissions: 'all',
      },
    ],
  },
]

export const StatusColor: any = {
  active: 'success',
  inactive: 'warning',
  suspended: 'danger',
}

export const verfiyColor: any = {
  unverified: 'danger',
  verified: 'success',
}

export const DedicatedNumberBadge: any = {
  status: {
    active: 'green_text_badge badge-light-success',
    inactive: 'red_text_badge badge-light-danger',
    requested: 'blue_text_badge badge-light-warning',
    pending: 'yellow_text_badge badge-light-warning',
  },
  type: {
    sms: '',
    mms: '',
  },
}
